import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  children: React.ReactNode;
  className?: string;
  href?: string;
}
export function Button({
  variant = 'primary',
  children,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-3 rounded-full font-medium transition-all duration-300 text-lg tracking-wide';
  const variants = {
    primary: 'bg-gold-400 text-night-900 hover:bg-gold-500 hover:shadow-[0_0_20px_rgba(244,196,48,0.4)]',
    secondary: 'bg-earth-800 text-cream-50 hover:bg-earth-900 border border-earth-800 hover:border-gold-400/30',
    outline: 'bg-transparent border-2 border-gold-400 text-gold-400 hover:bg-gold-400/10 hover:shadow-[0_0_15px_rgba(244,196,48,0.2)]'
  };
  const combinedClassName = `${baseStyles} ${variants[variant]} ${className}`;
  if (href) {
    return <motion.a href={href} className={combinedClassName} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-198" data-mp="jnxva9th8rv0">
        {children}
      </motion.a>;
  }
  return <motion.button className={combinedClassName} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-199" data-mp="tku46gnafg03">
      {children}
    </motion.button>;
}